import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Clock, XCircle, ArrowLeft, Loader2 } from "lucide-react";

const PagamentoResultadoPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const status = searchParams.get("status");
  const paymentId = searchParams.get("payment_id");
  const [isValid, setIsValid] = useState(false);

  const validStatuses = ["success", "pending", "failure"];

  useEffect(() => {
    if (!status || !validStatuses.includes(status)) {
      navigate("/planos", { replace: true });
    } else {
      setIsValid(true);
    }
  }, [status, navigate]);

  useEffect(() => {
    if (isValid) {
      console.log("Payment result page - Status:", status, "Payment ID:", paymentId);
    }
  }, [isValid, status, paymentId]);

  if (!isValid) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  const getStatusContent = () => {
    switch (status) {
      case "success":
        return {
          icon: <CheckCircle className="h-16 w-16 text-success" />,
          title: "Pagamento Aprovado!",
          description: "Seu pagamento foi processado com sucesso. Seus créditos ou plano foram ativados.",
          variant: "success" as const,
        };
      case "pending":
        return {
          icon: <Clock className="h-16 w-16 text-warning" />,
          title: "Pagamento Pendente",
          description: "Seu pagamento está sendo processado. Você receberá uma confirmação assim que for aprovado.",
          variant: "pending" as const,
        };
      case "failure":
      default:
        return {
          icon: <XCircle className="h-16 w-16 text-destructive" />,
          title: "Pagamento Não Aprovado",
          description: "Infelizmente seu pagamento não foi aprovado. Por favor, tente novamente ou escolha outro método de pagamento.",
          variant: "failure" as const,
        };
    }
  };

  const content = getStatusContent();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 flex items-center justify-center py-12">
        <div className="container">
          <div className="max-w-lg mx-auto">
            <Card className="text-center">
              <CardHeader className="space-y-4">
                <div className="flex justify-center">
                  {content.icon}
                </div>
                <CardTitle className="text-2xl font-display">
                  {content.title}
                </CardTitle>
                <CardDescription className="text-base">
                  {content.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                {paymentId && (
                  <p className="text-sm text-muted-foreground">
                    ID do pagamento: <span className="font-mono">{paymentId}</span>
                  </p>
                )}
                
                <div className="flex flex-col gap-3 pt-4">
                  {status === "failure" && (
                    <Button asChild>
                      <Link to="/planos">Tentar Novamente</Link>
                    </Button>
                  )}
                  
                  <Button variant={status === "failure" ? "outline" : "default"} asChild>
                    <Link to="/empresa/dashboard">
                      <ArrowLeft className="mr-2 h-4 w-4" />
                      Ir para o Dashboard
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PagamentoResultadoPage;
